export const MAX_DATE = '3000-01-01';
